<template>
  <div>
    <el-form :model="searchItem" inline size="small">
      <el-form-item label="ID">
        <el-input v-model.trim="searchItem.id" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="应用名称">
        <el-select v-model="searchItem.app_store_id" filterable clearable>
          <el-option v-for="item in appList" :key="item.id" :value="item.id" :label="`${item.name}(${item.code})`"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应用数量">
        <el-input v-model.trim="searchItem.app_quantity" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="代金券状态">
        <el-select v-model="searchItem.status" clearable>
          <el-option v-for="item in voucherStatus" :key="item.id" :value="item.id" :label="item.msg"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="使用设备">
        <el-input v-model.trim="searchItem.sn" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="订单ID">
        <el-input v-model.trim="searchItem.order_id" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="代金券卡号">
        <el-input v-model.trim="searchItem.code" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="primary" @click="reset" plain>重置</el-button>
      </el-form-item>
    </el-form>
    <vue-table :table-data="tableData" :count-list="countList">
      <template slot="operateBar">
        <el-button size="small" type="primary" @click="doExport" :disabled="!tableData.tableList.length">导出</el-button>
      </template>
      <template slot="app_store_id" slot-scope="{row}">
        <span>{{formatId(row.app_store_id, appList)}}</span>
      </template>
      <template slot="app_duration" slot-scope="{row}">
        <span>{{formatDuration(row)}}</span>
      </template>
      <template slot="code" slot-scope="{row}">
        <el-row type="flex" align="middle">
          <span class="tooltip" :title="row.code">{{row.code}}</span>
          <el-button class="action-btn" type="text" size="mini" @click="copyText(row.code)">复制</el-button>
        </el-row>
      </template>
    </vue-table>
    <vue-pagination :paging-data="pagingData" @getData="getData" ref="paging"/>
  </div>
</template>

<script>
import {PagingData} from "@mixins"
import {voucherStatus,appPeriod} from "@utils/formatList";
export default {
  name: "index",
  mixins: [PagingData],
  data() {
    return {
      voucherStatus,
      appPeriodObj: this.formatToObj(appPeriod),
      searchItem: {
        id: "",
        order_id: "",
        app_store_id: "",
        app_quantity: "",
        status: "",
        sn: "",
        code: "",
      },
      commitItem: null,
      countList: [
        {name: "总记录", count: 0},
      ],
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "ID", property: "id"},
          {label: "订单ID", property: "order_id"},
          {label: "应用名称", property: "app_store_id"},
          {label: "应用数量", property: "app_quantity"},
          {label: "应用有效时长", property: "app_duration"},
          {label: "代金券卡号", property: "code", width: 300},
          {label: "代金券有效期", property: "expire_at"},
          {label: "代金券状态", property: "status", format: voucherStatus},
          {label: "使用设备", property: "sn"},
          {label: "使用时间", property: "active_at"},
        ],
      },
      appList: [],
    }
  },
  methods: {
    async doExport() {
      const nv = {};
      this.copyObjValue(nv, this.commitItem);
      const res = await this.$Http.exportVoucher(nv);
      if (res?.data) {
        const content = res.data || "";
        let blob = new Blob(["\ufeff" + content], { type: "text/plain", endings: "transparent" });
        this.downloadFile(`voucher-${this.getCurrentTime()}`, blob, ".csv");
      }
    },
    formatId(id, list) {
      return list.find(item => item.id === id)?.name || "-"
    },
    formatDuration(row) {
      return `${row.app_duration}${this.appPeriodObj[row.app_period]}`
    },
    search() {
      this.commitItem = {...this.searchItem};
      this.pagingData.currentPage = 1;
      this.getData();
    },
    reset() {
      Object.keys(this.searchItem).forEach(key => this.searchItem[key] = "");
      this.search();
    },
    async getData() {
      let nv = {
        page: this.pagingData.currentPage,
        limit: this.pagingData.pageSize,
      };
      this.copyObjValue(nv, this.commitItem);
      const res = await this.$Http.getAppVoucherList(nv);
      if (res?.data) {
        let total = +res.data.total || 0;
        this.pagingData.total = total;
        this.countList[0].count = total;
        this.tableData.tableList = res.data.list || [];
      }
    },
    async getApp() {
      const res = await this.$Http.getAppOption();
      if (res?.data) {
        this.appList = res.data || [];
      }
    },
  },
  mounted() {
    this.getApp();
    this.getData();
  }
}
</script>

<style scoped lang="scss">

</style>

